<template>
  <div class="img-upload">
    <div
      v-for="(pic, index) in pics"
      :key="pic.id"
      class="upload-item"
      :class="{
        'curr-item': pic.canUpload && !pic.fileUrl,
        'show-img': pic.fileUrl
      }"
      @click="addPhoto(pic, index)"
    >
      <div class="curr">
        <img src="@/images/market_research/icon_camera.png" />
        <span>添加图片</span>
      </div>
      <img
        v-if="pic.fileUrl"
        :src="adaptOssImage(pic.fileUrl, resl)"
        @error="imgLoadFail"
        @click.stop="showImg(pic.fileUrl)"
      />
      <div v-show="pic.fileUrl" class="close-btn" @click.stop="delPhoto(index)">
        <div class="bg"></div>
        <img src="@/images/market_research/icon_close.png" />
        <!-- <IconFont
          name="mc-icon-guanbi"
          size="14px"
          color="#666"
          class="icon-font"
        ></IconFont> -->
      </div>
    </div>
    <input
      ref="uploader"
      type="file"
      class="file-uploader"
      accept="image/*"
      @change="onFileChange"
    />
  </div>
</template>

<script>
import {
  ossImage,
  imgLoadFail,
  onLoadP,
  compressImage
} from '@/utils/oss_image'
import { API } from '@/api'
import { cityId, companyId } from '@/defines/user'

const MAX_UPLOAD = 3

export default {
  name: 'TaskImgUpload',
  // eslint-disable-next-line vue/require-prop-types
  inject: ['ossData', 'showImg'],
  props: {
    taskData: {
      type: Object,
      default: () => {}
    },
    showPics: {
      type: Array,
      default: () => []
    }
  },
  data() {
    const pics = []
    for (var i = 0, len = MAX_UPLOAD; i < len; i++) {
      pics.push({
        id: i,
        fileId: '',
        fileUrl: '',
        canUpload: i === 0
      })
    }
    return {
      pics: pics,
      // eslint-disable-next-line camelcase
      // resl: Math.floor( * 2.2 * 4)
      resl: 440
    }
  },
  created() {
    this.showPics.forEach((item, index) => {
      this.pics[index].fileUrl = item
      this.pics[index + 1].canUpload = true
    })
  },
  methods: {
    imgLoadFail,
    adaptOssImage(src, width = 0, height = 0) {
      return ossImage({
        src,
        width,
        height
      })
    },
    init() {
      this.pics = []
      for (var i = 0, len = MAX_UPLOAD; i < len; i++) {
        this.pics.push({
          id: i,
          fileId: '',
          fileUrl: '',
          canUpload: i === 0
        })
      }
    },
    async onFileChange(e) {
      const file = e.target.files[0]

      // const { name, type } = file
      if (file) {
        this.$Loading()
        const ossData = this.ossData.ossData
        try {
          const result = await compressImage({
            file,
            targetSize: 400 * 1024, // 400kb
            maxWidth: 1080,
            quality: 0.8
          })
          const compressImg = new File([result], file.name, {
            type: file.type
          })
          const data = await onLoadP({
            ossData,
            file: compressImg,
            path: ''
          })

          const res = await API.marketResearch.upOcr({
            taskId: this.taskData.taskId,
            imgPath: data.data.furl,
            cityId,
            companyId,
            opponentPlatformId: this.taskData.platformId,
            searchWord: this.taskData.searchWord,
            class1Id: this.taskData.class1Id
          })
          this.$Loading.hide()
          if (res === null) {
            this.$refs.uploader.value = ''
            this.$toast(
              '服务器繁忙，请上传更清晰的图片，如持续未解决请联系城市对接人'
            )
            return
          }
          if (res.isBlocked === 0) {
            this.updateImg(data)
          } else {
            this.$toast(res.desc)
            if (res.desc !== '图片禁止重复使用，请重新提交图片') {
              await API.marketResearch.deleteUpOcr({
                taskId: this.taskData.taskId,
                imgPath: data.data.furl,
                cityId,
                companyId,
                opponentPlatformId: this.taskData.platformId,
                searchWord: this.taskData.searchWord
              })
            }
          }
        } catch (error) {
          this.$Loading.hide()
          if (error.message) {
            this.$toast(error.message)
          } else if (
            'status' in error &&
            'headers' in error &&
            'body' in error &&
            error.status === 413
          ) {
            this.$toast('系统忙，请稍后重试！')
          } else {
            this.$catch(error)
          }
        }
      }
      this.$refs.uploader.value = ''
    },
    updateImg(img) {
      const currPic = this.pics[this.currPicIndex]
      const pic = img.data
      currPic.fileId = '/' + pic.fid
      currPic.fileUrl = pic.furl
      if (this.pics.length - 1 > this.currPicIndex) {
        this.pics[this.currPicIndex + 1].canUpload = true
      }
      this.updateFile()
    },
    addPhoto(item, index) {
      if (item.canUpload) {
        this.currPicIndex = index
        this.$refs.uploader.click()
      }
    },
    async delPhoto(index) {
      const pic = this.pics[index]
      const res = await API.marketResearch.deleteUpOcr({
        taskId: this.taskData.taskId,
        imgPath: pic.fileUrl,
        cityId,
        companyId,
        opponentPlatformId: this.taskData.platformId,
        searchWord: this.taskData.searchWord
      })

      if (res.isDelete === 1) {
        this.$toast({ message: '删除成功' })
      }

      // this.pics.remove(pic)
      // this.pics.push(pic)
      pic.fileId = ''
      pic.fileUrl = ''
      // pic.canUpload = false
      pic.canUpload = true

      // index = -1
      // this.pics.forEach((pic, idx) => {
      //   if (!pic.fileId && index < 0) {
      //     pic.canUpload = true
      //     index = idx
      //   } else if (!pic.fileId) {
      //     pic.canUpload = false
      //   }
      // })
      this.updateFile()
    },
    updateFile() {
      this.$nextTick(() => {
        if (this.$refs.uploader) {
          this.$refs.uploader.value = ''
        }

        this.$emit(
          'update:upPics',
          this.pics.filter(pic => pic.fileUrl).map(pic => pic.fileUrl)
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.img-upload {
  .upload-item {
    display: inline-block;

    position: relative;

    width: 1.52rem;
    height: 1.52rem;
    margin-right: 0.14rem;

    background: #fff;

    border-radius: 0.16rem;

    vertical-align: top;

    .curr {
      display: none;
    }
    img {
      width: 100%;
      max-height: 100%;
    }

    &.show-img {
      border: 0 none;
    }
    &.curr-item {
      background-color: #fff;
      border: 0.02rem solid #f5f5f5 !important;
      .curr {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 100%;

        font-size: 0.24rem;
        color: #262626;
        font-weight: 400;
        img {
          width: 0.56rem;
          height: 0.56rem;
          margin-bottom: 0.08rem;
        }
      }
    }
  }
}

.file-uploader {
  display: none;
}

.close-btn {
  position: absolute;
  top: -0.12rem;
  right: -0.12rem;
  display: flex;
  justify-content: center;
  align-items: center;

  width: 0.32rem;
  height: 0.32rem;

  .bg {
    background-color: #fff;
    width: 0.28rem;
    height: 0.28rem;
    border-radius: 50%;
  }
  img {
    position: absolute;
    top: 0;
    left: 0;
  }
}
</style>
